import { Directive, ElementRef, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { UploadOutput, UploaderOptions } from '../model/f-file-upload.model';
import { FFileUploaderService } from '../service/f-file-uploader.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[FFileSelect]'
})
export class FFileSelectDirective implements OnInit, OnDestroy {
  private tDisabled = false;
  @Input()
  set disabled(value: boolean) {
    if (this.tDisabled !== value) {
      this.tDisabled = value;
      if (value) {
        this.unbindEvent();
      } else {
        this.bindEvent();
      }
    }
  }
  get disabled(): boolean {
    return this.tDisabled;
  }
  @Input()
  set options(value: UploaderOptions) {
    if (value) {
      this.upload.setOptions(value);
    }
  };
   // 已上传
   @Input()
   set uploadedCount(value){
       this.upload.setOptions({'uploadedCount':value});
   }
  @Input() uploadInput: EventEmitter<any>;
  @Output() uploadOutput: EventEmitter<UploadOutput>;

  //upload: FFileUploaderService;
  el: HTMLInputElement;
  private _sub: Subscription[];
  private changeListener: any = null;

  constructor(public elementRef: ElementRef, private upload: FFileUploaderService) {
    this.uploadOutput = new EventEmitter<UploadOutput>();
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this._sub = [];
    // 对外抛出事件
    this._sub.push(
      this.upload.serviceEvents.subscribe((event: UploadOutput) => {
        this.uploadOutput.emit(event);
      })
    );
    // 对内的事件
    if (this.uploadInput instanceof EventEmitter) {
      this._sub.push(this.upload.initInputEvents(this.uploadInput));
    }
    if (!this.disabled) {
      this.bindEvent();
    }
  }
  private bindEvent() {
    this.changeListener = this.onChange.bind(this);
    this.el.addEventListener('change', this.changeListener);
  }
  private unbindEvent() {
    this.changeListener = null;
    this.el.removeEventListener('change', this.changeListener);
  }

  ngOnDestroy() {
    if (this.el) {
      this._sub.forEach(sub => sub.unsubscribe());
    }
  }

  onChange = () => {
    if (this.el.files) {
      this.upload.handleFiles(this.el.files);
      this.el.value=null;
    }
  }
  /**
   * 重置
   */
  reset(){
    // if (this.el) {
    //   //this._sub.forEach(sub => sub.unsubscribe());
    //   //this._sub=[];
    //   this.upload.reset();
    // }    
    this.upload.reset();
  }
}
